import "../../../assets/css/patients/addpatients/doctorslist.scss";
import doctor from "../../../assets/images/common/doctor.svg";

const DoctorsList = () => {
  const doctorDetail = [
    {
      id: 0,
      name: "Dr. Calvin Carlo",
      specialization: "Cardiologist",
      experience: "3 Years Experienced",
      image: doctor,
    },
    {
      id: 1,
      name: "Dr. Calvin Carlo",
      specialization: "Cardiologist",
      experience: "3 Years Experienced",
      image: doctor,
    },
    {
      id: 2,
      name: "Dr. Calvin Carlo",
      specialization: "Cardiologist",
      experience: "3 Years Experienced",
      image: doctor,
    },
    {
      id: 3,
      name: "Dr. Calvin Carlo",
      specialization: "Cardiologist",
      experience: "3 Years Experienced",
      image: doctor,
    },
    {
      id: 4,
      name: "Dr. Calvin Carlo",
      specialization: "Cardiologist",
      experience: "3 Years Experienced",
      image: doctor,
    },
    {
      id: 5,
      name: "Dr. Calvin Carlo",
      specialization: "Cardiologist",
      experience: "3 Years Experienced",
      image: doctor,
    },
  ];

  return (
    <div className="doctors-list-wrapper">
      <div className="header">
        <div className="title">Doctors List</div>
        <hr
          style={{
            borderColor: "border: 1px solid #E4E3E4 !important",
            margin: "0px",
          }}
        />
      </div>

      <div className="doctors-list">
        {doctorDetail.map((doctor) => {
          return (
            <div className="doctor-container" key={doctor.id}>
              <img src={doctor.image} />
              <div className="doctor-detail">
                <div className="name">{doctor.name}</div>
                <div className="specialization">{doctor.specialization}</div>
                <div className="experience">{doctor.experience}</div>
              </div>
            </div>
          );
        })}
      </div>
      <button className="">All Doctors</button>
    </div>
  );
};

export default DoctorsList;
